<template>
  <div class="profile-page-bg">
    <div class="profile-card">
      <h4 class="profile-title">我的资料</h4>
      <el-tabs v-model="activeTab" class="profile-tabs">
        <!-- 基本资料 Tab -->
        <el-tab-pane label="基本资料" name="profile-info">
          <el-form ref="profileForm" :model="profile" label-width="100px" class="profile-form">
            <el-form-item label="邮箱">
              <el-input v-model="profile.accountNumber" disabled class="profile-input disabled-input"></el-input>
            </el-form-item>
            <el-form-item label="机构">
              <el-input v-model="profile.institutionName" disabled class="profile-input disabled-input"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="profile.userName" class="profile-input"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input v-model="profile.phone" class="profile-input"></el-input>
            </el-form-item>
            <el-form-item class="profile-btn-group">
              <el-button type="primary" class="profile-btn save-btn" @click="onSave('基本资料')" :disabled="!isProfileChanged">保存</el-button>
              <el-button class="profile-btn cancel-btn" @click="onCancel">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <!-- 修改密码 Tab -->
        <el-tab-pane label="修改密码" name="change-password">
          <el-form ref="passwordForm" :model="passwordForm" label-width="100px" class="profile-form">
            <el-form-item label="邮箱">
              <el-input v-model="passwordForm.email" disabled class="profile-input disabled-input"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <div class="input-btn-inline">
                <el-input v-model="passwordForm.code" placeholder="请输入验证码" class="profile-input"></el-input>
                <el-button @click="sendCode('password')" type="primary" class="inline-btn" :disabled="codeSending.password">{{ codeSending.password ? `${countdown.password}s后重试` : '发送验证码' }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input v-model="passwordForm.newPassword" type="password" class="profile-input"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input v-model="passwordForm.confirmPassword" type="password" class="profile-input"></el-input>
            </el-form-item>
            <el-form-item class="profile-btn-group">
              <el-button type="primary" class="profile-btn save-btn" @click="onSave('修改密码')" :disabled="!canSubmitPassword">保存</el-button>
              <el-button class="profile-btn cancel-btn" @click="resetPasswordForm">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <!-- 邮箱转让 Tab -->
        <el-tab-pane label="邮箱转让" name="email-transfer">
          <el-form ref="emailTransferForm" :model="emailTransferForm" label-width="100px" class="profile-form">
            <el-form-item label="当前邮箱">
              <el-input v-model="emailTransferForm.currentEmail" disabled class="profile-input disabled-input"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <div class="input-btn-inline">
                <el-input v-model="emailTransferForm.currentCode" placeholder="请输入验证码" class="profile-input" @input="validateCurrentCode"></el-input>
                <el-button @click="sendCode('emailTransfer')" type="primary" class="inline-btn" :disabled="codeSending.current">{{ codeSending.current ? `${countdown.current}s后重试` : '发送验证码' }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label="新邮箱">
              <el-input v-model="emailTransferForm.newEmail" :disabled="!isCurrentCodeValid" class="profile-input"></el-input>
            </el-form-item>
            <el-form-item label="新邮箱验证码" style="white-space: nowrap;">
              <div class="input-btn-inline">
                <el-input v-model="emailTransferForm.newEmailCode" placeholder="请输入验证码" class="profile-input" @input="validateNewCode"></el-input>
                <el-button @click="sendCode('newEmail')" type="primary" class="inline-btn" :disabled="!isCurrentCodeValid || codeSending.new">{{ codeSending.new ? `${countdown.new}s后重试` : '发送验证码' }}</el-button>
              </div>
            </el-form-item>
            <el-form-item class="profile-btn-group">
              <el-button type="primary" class="profile-btn save-btn" @click="onSave('邮箱转让')" :disabled="!canSubmitEmailTransfer">保存</el-button>
              <el-button class="profile-btn cancel-btn" @click="resetEmailTransferForm">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import { EventBus } from '@/utils/eventBus'

export default {
  data() {
    return {
      activeTab: "profile-info",
      profile: {
        accountNumber: "",
        institutionName: "",
        userName: "",
        phone: "",
      },
      passwordForm: {
        email: "",
        code: "",
        newPassword: "",
        confirmPassword: "",
      },
      emailTransferForm: {
        currentEmail: "",
        currentCode: "",
        newEmail: "",
        newEmailCode: "",
      },
      originalProfile: {},
      isProfileChanged: false,
      codeSending: {
        password: false,
        current: false,
        new: false
      },
      countdown: {
        password: 60,
        current: 60,
        new: 60
      },
      serverCodes: {
        password: "",
        current: "",
        new: ""
      },
      canSubmitPassword: false,
      isCurrentCodeValid: false,
      canSubmitEmailTransfer: false,
    };
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const accountNumber = userInfo.accountNumber;
      if (!accountNumber) {
        this.$message.error('获取用户信息失败');
        return;
      }

      request.get(`/api/auth/selectTeachUsersByaccountNumber?accountNumber=${accountNumber}`)
        .then(response => {
          console.log('用户信息:', response);
          if (response.code === 0 && response.success) {
            // 更新 profile 数据
            this.profile = {
              accountNumber: response.data.accountNumber,
              userName: response.data.userName,
              phone: response.data.phone,
              institutionName: response.data.institutionName
            };

            // 更新其他表单的邮箱字段
            this.passwordForm.email = response.data.accountNumber;
            this.emailTransferForm.currentEmail = response.data.accountNumber;

            // 保存原始数据用于比较
            this.originalProfile = { ...this.profile };
          } else {
            this.$message.error(response.msg || '获取用户信息失败');
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error);
          this.$message.error(error.message || '获取用户信息失败');
        });
    },

    checkProfileChanged() {
      const hasNameChanged = this.profile.userName !== this.originalProfile.userName;
      const hasPhoneChanged = this.profile.phone !== this.originalProfile.phone;
      
      console.log('检查变更:', {
        current: { userName: this.profile.userName, phone: this.profile.phone },
        original: this.originalProfile,
        hasChanged: hasNameChanged || hasPhoneChanged
      });

      this.isProfileChanged = hasNameChanged || hasPhoneChanged;
    },

    onSave(tab) {
      if (tab === '基本资料') {
        const accountNumber = localStorage.getItem('userInfo');
        if (!accountNumber) {
          this.$message.error('获取用户信息失败');
          return;
        }

        const updateData = {
          accountNumber: accountNumber.replace(/^"|"$/g, ''),
          userName: this.profile.userName,
          phone: this.profile.phone
        };

        console.log('发送更新请求:', updateData);

        request.post('/api/auth/updateByAccountNumber', updateData)
          .then(response => {
            if (response.data.code === 0) {
              this.$message.success('保存成功！');
              this.originalProfile = {
                userName: this.profile.userName,
                phone: this.profile.phone
              };
              this.isProfileChanged = false;
              EventBus.$emit('userNameUpdated');
            } else {
              this.$message.error(response.data.msg || '保存失败');
            }
          })
          .catch(error => {
            console.error('保存失败:', error);
            this.$message.error('保存失败，请稍后重试');
          });
      } else if (tab === '修改密码') {
        // 验证码校验
        if (this.passwordForm.code !== this.serverCodes.password) {
          this.$message.error('验证码错误');
          return;
        }

        // 确认密码校验
        if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
          this.$message.error('两次输入的密码不一致');
          return;
        }

        // 发送修改密码请求
        const updateData = {
          accountNumber: this.passwordForm.email,
          // code: this.passwordForm.code,
          newPassword: this.passwordForm.newPassword
        };

        request.post('/api/auth/updatePassword', updateData)
          .then(response => {
            if (response.data.code === 0) {
              this.$message.success('密码修改成功！');
              this.resetPasswordForm();
            } else {
              this.$message.error(response.data.msg || '密码修改失败');
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.$message.error('密码修改失败');
          });
      } else if (tab === '邮箱转让') {
        // 修改验证逻辑
        if (!this.isCurrentCodeValid) {
          this.$message.error('当前邮箱验证码错误');
          return;
        }
        if (this.emailTransferForm.newEmailCode !== this.serverCodes.new) {
          this.$message.error('新邮箱验证码错误');
          return;
        }

        // 发送邮箱转让请求
        const updateData = {
          oldAccountNumber: this.emailTransferForm.currentEmail,
          newAccountNumber: this.emailTransferForm.newEmail
        };

        request.post('/api/auth/updateEmail', updateData)
          .then(response => {
            if (response.data.code === 0) {
              this.$message.success('邮箱转让成功！');
              this.resetEmailTransferForm();
              // this.fetchData();
              this.$router.push('/login')
            } else {
              this.$message.error(response.data.msg || '邮箱转让失败');
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            // console.error('邮箱转让失败:', error);
            this.$message.error('邮箱转让失败');
          });
      }
    },
    onCancel() {
      // 取消时恢复原始数据
      this.profile.userName = this.originalProfile.userName;
      this.profile.phone = this.originalProfile.phone;
      this.isProfileChanged = false;
      this.$message({
        type: "info",
        message: "已取消修改",
      });
    },
    sendCode(type) {
      let email = '';
      let codeType = type;

      switch (type) {
        case 'emailTransfer':
          email = this.emailTransferForm.currentEmail;
          codeType = 'current';
          break;
        case 'newEmail':
          email = this.emailTransferForm.newEmail;
          codeType = 'new';
          break;
        default:
          email = this.passwordForm.email;
          break;
      }

      if (this.codeSending[codeType]) return;

      this.codeSending[codeType] = true;

      request.post(`/api/email/send?to=${email}`)
        .then(response => {
          if (response.data.code === 0) {
            this.$message.success('验证码已发送到邮箱');
            this.serverCodes[codeType] = response.data.data;
            this.startCountdown(codeType);
          } else {
            this.$message.error(response.data.msg || '验证码发送失败');
            this.codeSending[codeType] = false;
          }
        })
        .catch(error => {
          console.error('验证码发送失败:', error);
          this.$message.error('验证码发送失败');
          this.codeSending[codeType] = false;
        });
    },

    // 统一的倒计时方法
    startCountdown(type) {
      this.countdown[type] = 60;
      const timer = setInterval(() => {
        if (this.countdown[type] > 0) {
          this.countdown[type]--;
        } else {
          this.codeSending[type] = false;
          clearInterval(timer);
        }
      }, 1000);
    },

    // 重置密码表单
    resetPasswordForm() {
      this.passwordForm = {
        email: this.passwordForm.email, // 保留邮箱
        code: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.canSubmitPassword = false;
      // this.$message.info('已重置表单');
    },

    // 检查密码表单是否可提交
    checkPasswordForm() {
      this.canSubmitPassword =
        this.passwordForm.code &&
        this.passwordForm.newPassword &&
        this.passwordForm.confirmPassword &&
        this.passwordForm.newPassword === this.passwordForm.confirmPassword;
    },

    // 验证当前邮箱验证码
    validateCurrentCode() {
      // 只有当验证码长度大于等于4时才进行验证
      if (this.emailTransferForm.currentCode.length >= 4) {
        setTimeout(() => {
          if (String(this.emailTransferForm.currentCode) !== String(this.serverCodes.current)) {
            this.$message.error('验证码错误')
            this.isCurrentCodeValid = false;
            
          } else {
            this.$message.success('验证码正确')
            this.isCurrentCodeValid = true;
            
          }
          this.checkCanSubmit();
        }, 1000);
      }
    },

    // 验证新邮箱验证码
    validateNewCode() {
      if (this.emailTransferForm.newEmailCode.length >= 4) {
        setTimeout(() => {
          if (String(this.emailTransferForm.newEmailCode) !== String(this.serverCodes.new)) {
            this.$message.error('验证码错误')
          } else {
            this.$message.success('验证码正确')
          }
          this.checkCanSubmit();
        }, 1000);
      }
    },

    // 检查是否可以提交
    checkCanSubmit() {
      // 修改判断逻辑
      const isCurrentCodeValid = this.emailTransferForm.currentCode === this.serverCodes.current;
      const isNewCodeValid = this.emailTransferForm.newEmailCode === this.serverCodes.new;

      this.isCurrentCodeValid = isCurrentCodeValid;
      this.canSubmitEmailTransfer = isCurrentCodeValid &&
        this.emailTransferForm.newEmail &&
        isNewCodeValid;

    },

    // 重置邮箱转让表单
    resetEmailTransferForm() {
      this.emailTransferForm = {
        currentEmail: this.emailTransferForm.currentEmail,
        currentCode: "",
        newEmail: "",
        newEmailCode: "",
      };
      this.isCurrentCodeValid = false;
      this.canSubmitEmailTransfer = false;
      // 清除存储的验证码
      this.serverCodes.current = "";
      this.serverCodes.new = "";
      // this.$message.info('已重置表单');
    },
  },
};
</script>

<style scoped>
.profile-page-bg {
  min-height: 100vh;
  background: #EBF5FF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.profile-card {
  width: 1557px;
  height: 868px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.07);
  padding: 40px 60px 0 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.profile-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 18px;
  text-align: left;
}

.profile-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.profile-tabs :deep(.el-tabs__header) {
  margin-bottom: 24px;
}

.profile-tabs :deep(.el-tabs__item) {
  font-size: 16px;
  color: #666;
  padding: 0 32px;
  height: 42px;
  line-height: 42px;
}

.profile-tabs :deep(.el-tabs__item.is-active) {
  color: #409EFF;
  font-weight: bold;
}

.profile-tabs :deep(.el-tabs__active-bar) {
  background-color: #409EFF;
  height: 3px;
  border-radius: 2px;
}

.profile-form {
  margin-top: 0;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item :deep(.el-form-item__label) {
  color: #333;
  font-size: 15px;
  line-height: 40px;
  padding-right: 16px;
}

.profile-input {
  width: 100%;
  height: 40px;
}

.profile-input :deep(.el-input__inner) {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #fff;
  font-size: 15px;
  color: #333;
  padding: 0 16px;
  box-sizing: border-box;
}

.disabled-input :deep(.el-input__inner) {
  background: #F5F7FA !important;
  color: #999 !important;
  cursor: not-allowed;
}

.profile-btn-group {
  display: flex;
  justify-content: center;
  margin-top: 38px;
}

.profile-btn {
  min-width: 120px;
  height: 42px;
  font-size: 16px;
  border-radius: 6px;
  margin-right: 24px;
}

.save-btn {
  background: #409EFF;
  color: #fff;
  border: none;
}
.save-btn[disabled] {
  background: #a0cfff;
  color: #fff;
}
.cancel-btn {
  background: #fff;
  color: #606266;
  border: 1px solid #DCDFE6;
}

.input-btn-inline {
  display: flex;
  align-items: center;
}
.inline-btn {
  margin-left: 12px;
  height: 40px;
  /* 保证与输入框高度一致，可根据实际输入框高度微调 */
  padding: 0 20px;
}

/* 响应式适配 */
@media (max-width: 1600px) {
  .profile-card {
    width: 100%;
    max-width: 100vw;
    height: auto;
    min-height: 600px;
    padding: 32px 20px 0 20px;
  }
}
@media (max-width: 900px) {
  .profile-card {
    min-width: 0;
    width: 100%;
    padding: 12px 4vw 0 4vw;
  }
  .profile-btn-group {
    flex-direction: column;
    align-items: center;
  }
  .profile-btn {
    margin: 0 0 12px 0;
    width: 100%;
    min-width: 0;
  }
}
</style>
